const MS_PER_MINUTE = 60 * 1000;
const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;

/**
 * "2d 14h 32m" until the deadline, dropping leading zero units ("14h 32m",
 * "32m"). Null once the deadline has passed, or when it can't be read, so a
 * stale gameweek never shows a countdown to a moment already gone.
 */
export const formatTimeUntilDeadline = (
  deadlineAt: string,
  nowMs: number
): string | null => {
  const deadlineMs = Date.parse(deadlineAt);
  if (Number.isNaN(deadlineMs)) return null;

  const totalMinutes = Math.floor((deadlineMs - nowMs) / MS_PER_MINUTE);
  if (totalMinutes < 1) return null;

  const days = Math.floor(totalMinutes / MINUTES_PER_DAY);
  const hours = Math.floor((totalMinutes % MINUTES_PER_DAY) / MINUTES_PER_HOUR);
  const minutes = totalMinutes % MINUTES_PER_HOUR;

  if (days > 0) return `${days}d ${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
};
